import { all, call, takeLatest, put } from 'redux-saga/effects';

import { DATA_REQUEST_BEGIN } from 'app/dealer/shared/higherOrderReducers/withDataRequest/actionTypeFormatters';
import { getDateRangeAsync } from 'app/dealer/shared/modules/dealersInsights/redux/dateRange/sagas';
import { removeTooltips } from 'app/dealer/shared/utils/dom/dom';

import { getLeadsDataAsync } from '../leads/sagas';
import { getLeadsYearlyOverviewDataAsync } from '../yearlyOverview/sagas';
import { LEADS_BENCHMARK_REDUCER_NAME } from '../constants';

import { leadsBenchmarkDataRequestComplete } from './actions';

/**
 * @description
 * main worker saga
 * this is called on every data request
 * to ensure all necessary data is available
 */
export function* getLeadsBenchmarkDataAsync() {
  removeTooltips();
  const hasDateRange = yield call(getDateRangeAsync);

  // if there is a date range, continue saga
  // fetch leads data and yearly overview data
  if (hasDateRange) {
    yield all([call(getLeadsDataAsync), call(getLeadsYearlyOverviewDataAsync)]);
  }
  // notify us when the saga is over - success or fail
  yield put(leadsBenchmarkDataRequestComplete());
}

/**
 * @description
 * watcher sagas
 */
export function* watchGetDataRequest() {
  yield takeLatest(
    DATA_REQUEST_BEGIN(LEADS_BENCHMARK_REDUCER_NAME),
    getLeadsBenchmarkDataAsync,
  );
}

/**
 * @description
 * root saga
 */
export function* watchLeadsBenchmarkGeneralSagas() {
  yield all([call(watchGetDataRequest)]);
}
